module.exports = __webpack_public_path__ + "img/NMerchantTransport64_ua.17a5cbbc.webp";